import type { InspectionTour } from '../api/inspections';
import { ca } from '../i18n/ca';

/** Why the tour stands where it stands, as a sentence; null when it simply waits or is done. */
export function tourReason(tour: InspectionTour): string | null {
  const r = ca.inspectionReviewPage.tour.reasons;
  switch (tour.reason) {
    case 'superseded':
      return r.superseded(tour.supersededBy);
    case 'old':
      return r.old;
    case 'no_captures':
      return r.no_captures;
    case 'withheld':
      return r.withheld;
    case 'dismissed':
      return tour.dismissReason ? `${r.dismissed} «${tour.dismissReason}»` : r.dismissed;
    case 'reopened':
      return r.reopened;
    default:
      return null;
  }
}
